/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Address information for organization matching.
 * @export
 * @interface ControlAddress
 */
export interface ControlAddress {
    /**
     * 
     * @type {string}
     * @memberof ControlAddress
     */
    street_line_1?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAddress
     */
    street_line_2?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAddress
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAddress
     */
    administrative_area?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAddress
     */
    postal_code?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAddress
     */
    country?: string;
}

/**
 * Check if a given object implements the ControlAddress interface.
 */
export function instanceOfControlAddress(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlAddressFromJSON(json: any): ControlAddress {
    return ControlAddressFromJSONTyped(json, false);
}

export function ControlAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'street_line_1': !exists(json, 'street_line_1') ? undefined : json['street_line_1'],
        'street_line_2': !exists(json, 'street_line_2') ? undefined : json['street_line_2'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'administrative_area': !exists(json, 'administrative_area') ? undefined : json['administrative_area'],
        'postal_code': !exists(json, 'postal_code') ? undefined : json['postal_code'],
        'country': !exists(json, 'country') ? undefined : json['country'],
    };
}

export function ControlAddressToJSON(value?: ControlAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'street_line_1': value.street_line_1,
        'street_line_2': value.street_line_2,
        'city': value.city,
        'administrative_area': value.administrative_area,
        'postal_code': value.postal_code,
        'country': value.country,
    };
}

